import axios from "~/plugins/axios";
import siviApi from "~/api/sivi";

const getSivi = (context, object) => {
  context.commit("SEARCH_STATIC_UPDATED", object);
};

const getSelectedAFDMessages = (context, object) => {
  context.commit("SELECT_AFD_MESSAGES_UPDATED", object);
};

const loadCustomerPolicies = (context, customerId) => axios.post("/web_api/v1/customer/by_name", {
  last_name: customerId,
})
  .then((response) => response.data);

const selectCustomer = (context, object) => {
  context.commit("SELECT_CUSTOMER", object);
};

const loadCustomerPolicyInformation = (context, selectedCustomerId) => {
  context.commit("CLEAR_CHOSEN_PACKAGE");
  axios.post(`/web_api/v1/policy/policy_match_overview_by_customer/${selectedCustomerId}`)
    .then((response) => {
      context.commit("SET_CUSTOMER_POLICY_INFORMATION", {
        linkOptions: response.data.data.linkOptions,
        currentPackages: response.data.data.currentPackages,
        packageMessageOptions: response.data.data.packageMessageOptions,
      });
    });
};

const setNewCustomerPolicyInformation = (context) => {
  context.commit("CLEAR_CHOSEN_PACKAGE");
  context.commit("SET_CUSTOMER_POLICY_INFORMATION", {
    linkOptions: {
      newPackage: {
        newPackage: "Het nieuwe pakket", newPolicy: "Nieuwe polis",
      },
    },
    currentPackages: [],
    packageMessageOptions: {
      newPackage: "Nieuw pakket",
    },
  });
};

const setChosenPackage = (context, chosenPackageId) => {
  context.commit("SET_CHOSEN_PACKAGE", chosenPackageId);
};

const findCustomers = (context, afdMessageId) => {
  axios.get(`/web_api/v1/customer/${afdMessageId}/find_by_a_f_d_message/`, {
    params: {
      includes: "current_visit_customer_property.property",
    },
  })
    .then((response) => {
      context.commit("SET_FOUND_CUSTOMERS", response.data.data);
    });
};

const handleSaveAttachmentsChosen = (context, {
  policyMessage, saveAttachments,
}) => {
  context.commit("SET_SAVE_ATTACHMENTS", {
    policyMessage, saveAttachments,
  });
};

const deselectAllUnprocessedPackageMessages = (context) => {
  context.commit("DESELECT_ALL_UNPROCESSED_PACKAGE_MESSAGES");
};
const deselectUnprocessedPackageMessage = (context, messageId) => {
  context.commit("DESELECT_UNPROCESSED_PACKAGE_MESSAGE", messageId);
};

const fetchPaginatedUnprocessedPackageMessages = ({
  state, commit,
}, {
  filters, includes, order, orderBy, page, pageName, perPage,
}) => {
  if (state.fetchingPaginatedUnprocessedPackageMessages === false) {
    commit("SET_FETCHING_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES", true);

    siviApi.paginateUnprocessedPackageMessages(filters, includes, order, orderBy, page, pageName, perPage)
      .then((response) => {
        commit("SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES", response);
      })
      .finally(() => {
        commit("SET_FETCHING_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES", false);
      });
  }
};

const rejectUnprocessedPackageMessage = (context, messageId) => siviApi.rejectAfdMessage(messageId)
  .then((response) => {
    context.commit("DELETE_UNPROCESSED_PACKAGE_MESSAGE", response.data.id);
    context.commit("DESELECT_UNPROCESSED_PACKAGE_MESSAGE", response.data.id);
    context.commit("DECREMENT_UNPROCESSED_PACKAGE_MESSAGE_COUNT");
  });

const rejectUnprocessedPackageMessages = (context, messageIds) => siviApi.rejectAfdMessages(messageIds)
  .then((response) => {
    response.data.ids.forEach((id) => {
      context.commit("DELETE_UNPROCESSED_PACKAGE_MESSAGE", id);
      context.commit("DESELECT_UNPROCESSED_PACKAGE_MESSAGE", id);
      context.commit("DECREMENT_UNPROCESSED_PACKAGE_MESSAGE_COUNT");
    });
  });

const selectUnprocessedPackageMessage = (context, message) => {
  context.commit("SELECT_UNPROCESSED_PACKAGE_MESSAGE", message);
};

const setPaginatedUnprocessedPackageMessagesPage = (context, page) => {
  context.commit("SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_PAGE", page);
};
const setPaginatedUnprocessedPackageMessagesPerPage = (context, perPage) => {
  context.commit("SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_PER_PAGE", perPage);
};
const setPaginatedUnprocessedPackageMessagesOrder = (context, order) => {
  context.commit("SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_ORDER", order);
};
const setPaginatedUnprocessedPackageMessagesOrderBy = (context, orderBy) => {
  context.commit("SET_PAGINATED_UNPROCESSED_PACKAGE_MESSAGES_ORDER_BY", orderBy);
};

const approveUnprocessedPolicyMessage = (context, messageId) => siviApi.approveAfdMessage(messageId)
  .then((response) => {
    context.commit("DELETE_UNPROCESSED_POLICY_MESSAGE", response.data.id);
    context.commit("DESELECT_UNPROCESSED_POLICY_MESSAGE", response.data.id);
    context.commit("DECREMENT_UNPROCESSED_POLICY_MESSAGE_COUNT");
  });
const approveUnprocessedPolicyMessages = (context, messageIds) => siviApi.approveAfdMessages(messageIds)
  .then((response) => {
    response.data.ids.forEach((id) => {
      context.commit("DELETE_UNPROCESSED_POLICY_MESSAGE", id);
      context.commit("DESELECT_UNPROCESSED_POLICY_MESSAGE", id);
      context.commit("DECREMENT_UNPROCESSED_POLICY_MESSAGE_COUNT");
    });
  });

const deselectAllUnprocessedPolicyMessages = (context) => {
  context.commit("DESELECT_ALL_UNPROCESSED_POLICY_MESSAGES");
};
const deselectUnprocessedPolicyMessage = (context, messageId) => {
  context.commit("DESELECT_UNPROCESSED_POLICY_MESSAGE", messageId);
};

const fetchPaginatedUnprocessedPolicyMessages = ({
  state, commit,
}, {
  filters, includes, order, orderBy, page, pageName, perPage,
}) => {
  if (state.fetchingPaginatedUnprocessedPolicyMessages === false) {
    commit("SET_FETCHING_PAGINATED_UNPROCESSED_POLICY_MESSAGES", true);

    siviApi.paginateUnprocessedPolicyMessages(filters, includes, order, orderBy, page, pageName, perPage)
      .then((response) => {
        commit("SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES", response);
      })
      .finally(() => {
        commit("SET_FETCHING_PAGINATED_UNPROCESSED_POLICY_MESSAGES", false);
      });
  }
};

const rejectUnprocessedPolicyMessage = (context, messageId) => siviApi.rejectAfdMessage(messageId)
  .then((response) => {
    context.commit("DELETE_UNPROCESSED_POLICY_MESSAGE", response.data.id);
    context.commit("DESELECT_UNPROCESSED_POLICY_MESSAGE", response.data.id);
    context.commit("DECREMENT_UNPROCESSED_POLICY_MESSAGE_COUNT");
  });

const rejectUnprocessedPolicyMessages = (context, messageIds) => siviApi.rejectAfdMessages(messageIds)
  .then((response) => {
    response.data.ids.forEach((id) => {
      context.commit("DELETE_UNPROCESSED_POLICY_MESSAGE", id);
      context.commit("DESELECT_UNPROCESSED_POLICY_MESSAGE", id);
      context.commit("DECREMENT_UNPROCESSED_POLICY_MESSAGE_COUNT");
    });
  });

const selectUnprocessedPolicyMessage = (context, message) => {
  context.commit("SELECT_UNPROCESSED_POLICY_MESSAGE", message);
};

const setPaginatedUnprocessedPolicyMessagesOrder = (context, order) => {
  context.commit("SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_ORDER", order);
};
const setPaginatedUnprocessedPolicyMessagesOrderBy = (context, orderBy) => {
  context.commit("SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_ORDER_BY", orderBy);
};
const setPaginatedUnprocessedPolicyMessagesPage = (context, page) => {
  context.commit("SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_PAGE", page);
};
const setPaginatedUnprocessedPolicyMessagesPerPage = (context, perPage) => {
  context.commit("SET_PAGINATED_UNPROCESSED_POLICY_MESSAGES_PER_PAGE", perPage);
};

const setPackageMessageFilters = (context, filters) => {
  context.commit("SET_PACKAGE_MESSAGE_FILTERS", filters);
};

const initialisePackageMessageFilters = (context) => {
  context.commit("INITIALISE_PACKAGE_MESSAGE_FILTERS");
};

const setPolicyMessageFilters = (context, filters) => {
  context.commit("SET_POLICY_MESSAGE_FILTERS", filters);
};

const initialisePolicyMessageFilters = (context) => {
  context.commit("INITIALISE_POLICY_MESSAGE_FILTERS");
};

export default {
  getSivi,
  getSelectedAFDMessages,
  loadCustomerPolicies,
  selectCustomer,
  loadCustomerPolicyInformation,
  setNewCustomerPolicyInformation,
  setChosenPackage,
  findCustomers,
  handleSaveAttachmentsChosen,

  deselectAllUnprocessedPackageMessages,
  deselectUnprocessedPackageMessage,
  fetchPaginatedUnprocessedPackageMessages,
  rejectUnprocessedPackageMessage,
  rejectUnprocessedPackageMessages,
  selectUnprocessedPackageMessage,
  setPaginatedUnprocessedPackageMessagesOrder,
  setPaginatedUnprocessedPackageMessagesOrderBy,
  setPaginatedUnprocessedPackageMessagesPage,
  setPaginatedUnprocessedPackageMessagesPerPage,

  approveUnprocessedPolicyMessage,
  approveUnprocessedPolicyMessages,
  deselectAllUnprocessedPolicyMessages,
  deselectUnprocessedPolicyMessage,
  fetchPaginatedUnprocessedPolicyMessages,
  rejectUnprocessedPolicyMessage,
  rejectUnprocessedPolicyMessages,
  selectUnprocessedPolicyMessage,
  setPaginatedUnprocessedPolicyMessagesOrder,
  setPaginatedUnprocessedPolicyMessagesOrderBy,
  setPaginatedUnprocessedPolicyMessagesPage,
  setPaginatedUnprocessedPolicyMessagesPerPage,

  setPackageMessageFilters,
  initialisePackageMessageFilters,
  setPolicyMessageFilters,
  initialisePolicyMessageFilters,
};
